import { useFormikContext } from 'formik';

import { checkPreference } from '../../../flags';
import { translate } from '../../helpers/translate.helper';
import { LabelText } from '../../LabelText/LabelText';
import { PreformattedText } from '../../PreformattedText/PreformattedText';
import { Box } from '../../ui/Box';

export const FormikDebug = () => {
    const { values, errors } = useFormikContext();

    if (!checkPreference('FormikDebugTools')) {
        return null;
    }

    return (
        <Box display="flex" flexDirection="column" gap={16} marginTop={40} paddingBottom={40}>
            <Box>
                <LabelText>{translate('devTools.formikDebug.values')}</LabelText>
                <PreformattedText>{JSON.stringify(values, null, 2)}</PreformattedText>
            </Box>

            <Box>
                <LabelText>{translate('devTools.formikDebug.errors')}</LabelText>
                <PreformattedText>{JSON.stringify(errors, null, 2)}</PreformattedText>
            </Box>
        </Box>
    );
};
